import useMedia from './useMedia';

const useMobile = () => {
  return useMedia(['(max-width: 767px)'], [true], false);
};

export default useMobile;
